export default "__VITE_ASSET__BjfpijN2__"